
import dateFormat from 'vux/src/tools/date/format.js'

export default {
data() {
return {
calendarWeek: ['日', '一', '二', '三', '四', '五', '六']
}
},
create() {
alert(getCountDays())
},
computed: {
nowDate() {
return dateFormat(new Date(), 'YYYY-MM-DD');
},
getCountDays() { // 计算一个月与多少天
let curDate = new Date();
/* 获取当前月份 */
let curMonth = curDate.getMonth();
/*  生成实际的月份: 由于curMonth会比实际月份小1, 故需加1 */
curDate.setMonth(curMonth + 1);
/* 将日期设置为0, 这里为什么要这样设置, 我不知道原因, 这是从网上学来的 */
curDate.setDate(0);
/* 返回当月的天数 */
var dayNum = curDate.getDate();
var weekNum = (new Date(`${curDate.getFullYear()},${curMonth + 1}, 01`)).getDay()
var arr = [];
for (let i = 0; i < weekNum; i++) {
arr.push("");
};
for (let i = 0; i < dayNum; i++) {
arr.push(i + 1);
};
return arr;

}
},
methods: {
addClass(val) {
return this.siginList.indexOf(val) == '-1' ? false : true;
}
},
props: ['nowDay', 'siginList', "getNum"],
}



// WEBPACK FOOTER //
// ./src/components/HomeSignIn/Calendar.vue